const PATHS = {};

PATHS.LOGIN = "/login";
PATHS.HOME = "/user/home";
PATHS.ACCOUNT_LINKS = "/user/accountLinks";
PATHS.VIEW_RESUME_ACCOUNT_LINKS = "/user/accountLinks/resume/:uuid";
PATHS.GENERATE_ACCOUNT_LINKS = "/user/accountLinks/generate";
PATHS.DETAILS_ACCOUNT_LINKS = "/user/accountLinks/details/:ceco/:uuid/:account";

PATHS.CAPTIO_CONCEPTS_LIST = "/user/captioConcepts";

PATHS.NEW_EMPLOYEE = "/employee/new";
PATHS.REQUEST_EMPLOYEES = "/employee/new";

PATHS.EXTERNAL_CONFIRM_LOGIN = "/authConfirm/:token";

PATHS.WORKING_PART_SNAP_LIST = "/user/workingPart/snapList";
PATHS.WORKING_PART_SNAP_DETAIL = "/user/workingPart/snapDetail/:uuid";

export default PATHS;
